import { BonusSettlementCustomerStatus } from '@synergy/models';
import { BooleanFilter, FilterModal, SearchFilter, StatusFilter } from '@synergy/components';

export const BonusSettlementCustomerOverviewFilter = () => {
    return (
        <>
            <FilterModal>
                <StatusFilter
                    documentStatus={[
                        BonusSettlementCustomerStatus.Open,
                        BonusSettlementCustomerStatus.ReadyToComplete,
                        BonusSettlementCustomerStatus.Completed,
                    ]}
                />
                <BooleanFilter filterName="hasBonusPayout" labelTranslationId="app.select.option.bonusPayout" />
            </FilterModal>
            <SearchFilter />
        </>
    );
};
